import React, { Component } from 'react';
import helper from '../services/helper';

export default class Balance extends Component {
    handleClick() {
        this.props.onClick();
    }
    render() {
        let amount  = helper.formatAmount(this.props.amount);
        const style = {
            base: {
                display: 'inline-block',
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                padding: 30,
                textAlign: 'right',
                fontSize: 24,
                color: amount < 0 ? '#AA3F1D' : '#38B08C'
            }
        };
        return (
            <a style={style.base} onClick={this.handleClick.bind(this)}>{amount}</a>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Balance.js